const LISTAR_DADOS = (state, payload) => {
    state.items = payload
  }

const CARREGANDO = (state, payload) => {
  state.carregando = payload
}

const INSERIR_AUTENTICACAO_SELECIONADO = (state,  payload) => {
  state.selecionado = payload
}

const INSERIR_AUTENTICACAO = (state,  payload) => {
  state.items.push(payload)
}

const ATUALIZAR_AUTENTICACAO = (state, payload) => {
  state.items = state.items.map(autenticacao => {
    if(autenticacao.id === payload.id) {
      return payload;
    }
    return autenticacao
  })
}

export {
    LISTAR_DADOS,
    CARREGANDO,
    INSERIR_AUTENTICACAO_SELECIONADO,
    INSERIR_AUTENTICACAO,
    ATUALIZAR_AUTENTICACAO
}